import buttons from "./buttons";

const error_codes = {
	/* --------------------------- BACK OFFICE RELATED -------------------------- */
	BACK_OFFICE_DEBTOR_GROUP_MEMBER_EXISTS: "Deze debiteur bestaat al binnen deze debiteur groep.",

	// READ
	DADUP_ERR_1_NOT_FOUND: "Dadup niet gevonden",

	/* ------------------------------ DADUP RELATED ----------------------------- */
	// CREATE
	DADUP_ERR_2_COULD_NOT_CREATE_DADUP: "Dadup kan niet worden aangemaakt, neem contact op",

	DADUP_ERR_2_INVALID_DADUP_NAME: "Deze naam is niet toegestaan voor uw daDup account.",

	// DELETE
	DADUP_ERR_3_CANNOT_DELETE_WITH_BUCKETS:
		"Dadup account kan niet worden verwijderd als er nog buckets op het account staat",

	DADUP_ERR_3_COULD_NOT_CREATE_BUCKET:
		"Bucket kon niet worden aangemaakt, neem contact op met support",

	DADUP_ERR_4_INVALID_BUCKET_NAME: "Deze naam is niet toegestaan voor uw bucket.",

	DADUP_ERR_5_BUCKET_NAME_ALREADY_EXISTS:
		"Er bestaat al een bucket met deze naam onder een van uw daDup accounts.",

	DADUP_ERR_8_COULD_NOT_READ_DADUP: "Kon niet daDup lezen. neem contact op met support.",

	DADUP_ERR_9_HISTORY_USAGE_ERROR: "Kon niet het verbruik lezen van uw buckets",

	DADUP_ERR_10_REQUEST_ACCESS_TOKEN_ERROR: "Kon niet uw credentials ophalen",

	DADUP_ERR_11_COULD_NOT_READ_BUCKET: "Kon niet uw bucket(s) lezen",

	// Update
	DADUP_ERR_12_COULD_NOT_UPDATE_DADUP: "Kon niet daDup updaten.",

	DADUP_ERR_13_CREDENTIALS_SAVED_ERROR: "Kon niet opslaan dat u de gegevens hebt opgeslagen.",

	DADUP_ERR_14_CANNOT_DELETE_WITH_BUCKETS:
		"daDup account kon niet verwijderd worden, omdat er nog buckets aanwezig waren. Verwijder eerst alle buckets.",

	DADUP_ERR_15_COULD_NOT_DELETE_DADUP:
		"Kon niet uw daDup account verwijderen, neem contact op met support",

	DADUP_ERR_16_COULD_NOT_UPDATE_BUCKET: "Kon niet uw bucket bijwerken.",

	DADUP_ERR_17_COULD_NOT_DELETE_BUCKET:
		"Kon niet uw bucket verwijderen, neem contact op met support.",

	//GENERAL / OTHER
	DADUP_ERR_18_COULD_NOT_SEND_DADUP_NOTIFICATION: "Kon niet een notificatie versturen.",

	DADUP_ERR_19_COULD_NOT_HANDLE_DADUP_REQUEST:
		"Er is iets mis gegaan tijdens het verwerken van uw daDup aanvraag, neem contact op met support.",

	DADUP_ERR_20_COULD_NOT_HANDLE_BUCKET_REQUEST:
		"Er is iets mis gegaan tijdens het verwerken van uw bucket aanvraag, neem contact op met support",

	DADUP_ERR_21_COULD_NOT_UPDATE_DESCRIPTION:
		"Er is een fout opgetreden tijdens het bijwerken van de beschrijving. Probeer het op een later moment opnieuw.",

	/* ----------------------------- DEBTOR RELATED ----------------------------- */
	DEBTOR_ERR_1_PAID_SERVICES_DISABLED:
		"Betaalde diensten zijn niet beschikbaar voor uw account. Als u denkt dat dit niet klopt, neem dan contact op met onze klantenservice.",

	DEBTOR_ERR_2_DEBTOR_NOT_FOUND:
		"De debiteur is niet gevonden. Als dit niet klopt, neem dan contact op met onze klantenservice als dit probleem aanhoudt.",

	DEBTOR_ERR_4_DEBTOR_DISABLED_IN_COUNTRY: "Registratie is vanuit uw land niet toegestaan.",
	DEBTOR_ERR_5_FREELOADER_DISABLED_IN_COUNTRY:
		"Registraties voor particuliere gebruikers zijn vanuit uw land niet toegestaan.",

	DEBTOR_ERR_6_COMPANY_DETAILS_IDENTICAL_TO_TUXIS:
		"Uw BTW-nummer en/of KvK-nummer is identiek aan Tuxis. Dit is niet toegestaan.",

	DEBTOR_ERR_7_VIES_COUNTRY_CODE_NOT_MATCHING:
		"Het door u opgegeven btw-nummer komt niet overeen met het land dat u heeft geselecteerd.",

	DEBTOR_ERR_8_VIES_INVALID_NUMBER: "Het door u opgegeven BTW-nummer lijkt onjuist te zijn.",

	DEBTOR_ERR_9_VIES_COMMUNICATION_ERROR: `Er is een fout opgetreden bij VIES (VAT Information Exchange System) tijdens het controleren van het BTW nummer. Tuxis is op de hoogte gebracht en zal contact met u opnemen zodat uw account alsnog aangemaakt kan worden. U kunt het altijd nog een keer proberen door op "${buttons.sign_up}" te klikken of op een later moment opnieuw te registreren.`,

	DEBTOR_ERR_10_EMAIL_ADDRESS_NOT_EXISTS:
		"Het door u ingevoerde e-mailadres blijkt niet te bestaan.",

	/* ------------------------------- DNS RELATED ------------------------------ */
	DNS_ERR_1_DNS_TEMPLATE_NOT_FOUND:
		"DNS template niet gevonden, Controleer het bestaan van deze template.",

	DNS_ERR_2_FAILED_TO_READ_FROM_POWERDNS:
		"Er is iets fout gegaan tijdens het ophalen van informatie uit PowerDNS. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DNS_ERR_3_FAILED_TO_WRITE_TO_POWERDNS:
		"Er is iets fout gegaan tijdens het opslaan van naar PowerDNS. Check de waardes of neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DNS_ERR_4_FAILED_TO_DELETE_FROM_POWERDNS:
		"Er is iets fout gegaan tijdens het verwijderen van PowerDNS. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DNS_ERR_5_MULTIPLE_ENTRIES_NOT_ALLOWED:
		"Meerdere regels met de zelfde label zijn niet toegestaan voor sommige records, pas deze aan.",

	DNS_ERR_6_DOMAIN_1: "",

	DNS_ERR_7_A_1: "Een A-record moet een geldig IPv4-adres als waarde hebben.",

	DNS_ERR_8_AAAA_1: "Een AAAA record heeft een geldig IPv6 adres nodig als waarde.",

	DNS_ERR_9_ALIAS_1: "",

	DNS_ERR_10_CAA_1: "",

	DNS_ERR_11_CNAME_1: "Een CNAME-record kan geen @ als label hebben.",

	DNS_ERR_12_CNAME_2:
		"Een CNAME-record heeft een geldige domeinnaam als waarde nodig en moet eindigen op een punt.",

	DNS_ERR_13_CNAME_3:
		"Een CNAME-record kan niet meerdere vermeldingen voor hetzelfde label hebben.",

	DNS_ERR_14_CNAME_4: "Een CNAME-record kan niet hetzelfde label hebben als een A- of AAAA-record.",

	DNS_ERR_15_MX_1:
		"Een MX record heeft een geldige domeinnaam als waarde en moet eindigen op een punt.",

	DNS_ERR_16_LABEL_1: "Invalid label, check uw input.",

	DNS_ERR_17_NS_1: "Een NS-record kan geen @ als label hebben.",

	DNS_ERR_18_NS_2:
		"Een NS record heeft een geldige domeinnaam als waarde en moet eindigen op een punt.",

	DNS_ERR_19_NONE_1: "Ongeldig DNS-recordtype, Kies een geldig DNS-recordtype.",

	DNS_ERR_20_PTR_1: "",

	DNS_ERR_21_URI_1: "",

	DNS_ERR_22_SOA_1: "",

	DNS_ERR_23_SPF_1: "",

	DNS_ERR_24_SRV_1: "Ongeldig label voor SRV-record.",

	DNS_ERR_25_SRV_2: "Ongeldige waarde voor SRV-record.",

	DNS_ERR_26_TLSA_1: "",

	DNS_ERR_27_TXT_1: "",

	DNS_ERR_28_FAILED_TO_DELETE_DNS_ZONE:
		"Er is een probleem opgetreden tijdens het verwijderen van de DNS-zone van het domein. Neem contact op met onze klantenservice.",

	DNS_ERR_29_DNSSEC_KEY_INVALID_ALGORITHM:
		"Er is een fout opgetreden bij onze derde partij tijdens het aanmaken van de DNSSEC-sleutel. Neem contact op met onze klantenservice.",

	DNS_ERR_30_OXXA_ADD_DNSSEC_ITEM_FAILED:
		"Er is een fout opgetreden bij onze derde partij tijdens het activeren van DNSSEC voor dit domein. Neem contact op met onze klantenservice.",

	DNS_ERR_31_OXXA_DELETE_DNSSEC_ITEM_FAILED:
		"Er is een fout opgetreden bij onze derde partij tijdens het verwijderen van DNSSEC voor dit domein. Neem contact op met onze klantenservice.",

	DNS_ERR_32_POWERDNS_ADD_DNSSEC_ITEMS_FAILED:
		"Er is een fout opgetreden bij onze derde partij tijdens het activeren van DNSSEC voor dit domein. Neem contact op met onze klantenservice.",

	DNS_ERR_33_POWERDNS_READ_DNSSEC_ITEMS_FAILED:
		"Er is een fout opgetreden bij onze derde partij tijdens het ophalen van DNSSEC informatie voor dit domein. Neem contact op met onze klantenservice.",

	DNS_ERR_34_POWERDNS_DELETE_DNSSEC_ITEMS_FAILED:
		"Er is een fout opgetreden bij onze derde partij tijdens het verwijderen van DNSSEC voor dit domein. Neem contact op met onze klantenservice.",

	DNS_ERR_35_POWERDNS_NOT_ALLOWED_TO_READ_ZONE:
		"Deze debiteur heeft geen rechten om te lezen of te schrijven naar deze DNS zone. Als dit niet correct is, neem dan contact op met onze klantenservice.",

	DNS_ERR_36_PARSING_DNS_RECORDS_FAILED:
		"Er is een fout opgetreden tijdens het ophalen van de DNS-records. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DNS_ERR_37_SRV_3: "Gewichts- en poortnummers moeten tussen 0 en 65535 liggen",

	DNS_ERR_38_FAILED_TO_UPDATE_DNS_RECORD_ITEM:
		"Er is een fout opgetreden tijdens het updaten van een DNS-record regel. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	/* ----------------------------- DOMAIN RELATED ----------------------------- */
	DOMAIN_ERR_1_DOMAIN_NOT_FOUND:
		"Domein niet gevonden. Controleer of dit domein bestaat en of u de eigenaar bent van dit domein.",

	DOMAIN_ERR_2_DOMAIN_ALREADY_CANCELLED:
		"Domein is al geannuleerd. U kunt een reeds geannuleerd domein niet annuleren. Wilt u dit ongedaan maken? Neem dan contact op met onze klantenservice.",

	DOMAIN_ERR_3_DOMAIN_STILL_ACTIVE_OR_AUTORENEW_IS_ON:
		"Domein is nog actief en/of autorenew staat aan, schakel autorenew eerst uit.",

	DOMAIN_ERR_4_CANNOT_REVERSE_ACTION_ON_RENEWAL:
		"Je kunt de opzegging van een domein niet terugdraaien. Wilt u dit toch terugdraaien? Neem contact op met onze klantenservice.",

	DOMAIN_ERR_5_PRODUCT_DOMAIN_NOT_FOUND:
		"Domeinextensie niet gevonden, Als u zeker weet dat het zou moeten bestaan, neem dan contact op met onze klantenservice.",

	DOMAIN_ERR_6_PRODUCT_DOMAIN_IN_USE:
		"Kan geen productdomein aanmaken omdat deze al bestaat, gebruik de reeds bestaande.",

	DOMAIN_ERR_7_PRODUCT_DOMAIN_UNKNOWN_PRICE_COMMAND:
		"Deze opdracht wordt niet gebruikt om de prijs van de domeinextensie te controleren, neem contact op met support of dien een functieverzoek in als u wilt dat deze opdracht wordt toegevoegd.",

	DOMAIN_ERR_8_EXTERNAL_PARTY_ERROR:
		"Er is een fout opgetreden bij onze externe partij, dit komt hoogstwaarschijnlijk door een verkeerd ingevulde waarde of hun service is offline.",

	DOMAIN_ERR_9_HOSTFACT_HANDLE_NOT_FOUND:
		"De hostfact handle is niet gevonden, controleer of deze bestaat. Zo ja, neem dan contact op met een ontwikkelaar.",

	DOMAIN_ERR_10_FAILED_CREATING_OXXA_IDENTITY:
		"Er is iets misgegaan tijdens het aanmaken van een oxxa identiteit, dit komt waarschijnlijk door verkeerd ingevulde waarde of foutieve info over relatiedetails.",

	DOMAIN_ERR_11_FAILED_IMPORTING_DOMAIN:
		"Er is iets misgegaan tijdens het importeren van een domein uit hostfact. Controleer alle informatie zorgvuldig en of de juiste relatie is geselecteerd. Als het probleem zich blijft voordoen, neem dan contact op met een ontwikkelaar.",

	DOMAIN_ERR_12_DOMAIN_HAS_NO_DOMAIN_RELATION_DETAILS:
		"Dit domein heeft geen relatiedetails, voeg deze toe of controleer of de details juist zijn ingesteld.",

	DOMAIN_ERR_13_NO_SIMILAR_RELATIONS_FOUND:
		"Er is iets fout gegaan bij het vergelijken van relaties.",

	DOMAIN_ERR_14_QUEUE_INVALID_DOMAIN_STATUS:
		"Het geselecteerde domein heeft een status die de door u geselecteerde actie niet kan gebruiken. Controleer of u het juiste domein bijwerkt of vernieuw de pagina voor actuele domeinstatussen.",

	DOMAIN_ERR_15_NS_GROUP_NOT_FOUND: "Ns groep is niet gevonden voor dit domein.",

	DOMAIN_ERR_16_DEBTOR_ALREADY_USING_CUSTOM_NS_GROUP: "Uw account gebruikt al aangepaste NS-groep.",

	DOMAIN_ERR_17_NS_GROUP_NOT_ON_THIS_DOMAIN:
		"Ns groep is geen optie op dit domein of niet beschikbaar.",

	DOMAIN_ERR_18_FATAL_ERROR_WHILE_FETCHING_NS_GROUP:
		"Er is een fatale fout opgetreden tijdens het ophalen van de NS-groep, probeer het opnieuw of neem contact op met onze klantenservice.",

	DOMAIN_ERR_19_DOMAIN_NOT_RELATED_TO_ACCOUNT:
		"Domein is niet gerelateerd aan dit account. Controleer of u in het bezit bent van dit domein.",

	DOMAIN_ERR_20_TLD_DOES_NOT_USER_EPP: "Deze domeinextensie ondersteunt geen verhuiscodes.",

	DOMAIN_ERR_21_PRODUCT_DOMAIN_LOCKED_GROUP:
		"U kunt geen producten verwijderen uit een gelockte product group",

	DOMAIN_ERR_22_PRODUCT_DOMAIN_NOT_PRESENT_IN_GROUP:
		"Dit product is niet aanwezig in de groep, voeg deze eerst toe.",

	DOMAIN_ERR_23_PRODUCT_DOMAIN_ALREADY_PRESENT_IN_GROUP: "Dit product is al aanwezig in de groep.",

	DOMAIN_ERR_24_TLD_ACTION_NOT_ENABLED:
		"Er is een probleem opgetreden door een niet toegestane actie van een domeinextensie. Neem contact op met onze klantenservice.",

	DOMAIN_ERR_25_DOMAIN_NAME_TOO_SHORT_FOR_EXTENSION:
		"De domeinnaam voor deze domeinextensie is te kort. Maak een domeinnaam met een hoger aantal karakter.",

	DOMAIN_ERR_26_DOMAIN_NAME_TOO_LONG_FOR_EXTENSION:
		"De domeinnaam voor deze domeinextensie is te lang. Maak een domeinnaam met een lager aantal karakters.",

	DOMAIN_ERR_27_EXTENSION_DOES_NOT_ALLOW_NUMERIC_ONLY_DOMAIN_NAME:
		"Deze domeinextensie ondersteunt geen domeinnaam met alleen getallen. Getallen worden wel ondersteund wanneer er minimaal één letter in de naam voorkomt.",

	DOMAIN_ERR_28_FAILED_UPDATING_OXXA_IDENTITY:
		"Er is een fout opgetreden bij onze derde partij. Neem contact op met onze klantenservice.",

	DOMAIN_ERR_29_FAILED_DELETING_OXXA_IDENTITY:
		"Er is een fout opgetreden bij onze derde partij. Neem contact op met onze klantenservice.",

	DOMAIN_ERR_30_FAILED_UPDATING_DOMAIN:
		"Er is een probleem opgetreden bij onze derde partij tijdens het updaten van het domein. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DOMAIN_ERR_31_PRODUCT_DOMAIN_REQUIRES_EPP_CODE_FOR_EDIT_DOMAIN:
		"Dit domein heeft een verhuiscode nodig om het domein te kunnen bewerken.",

	DOMAIN_ERR_32_FAILED_TO_READ_DOMAIN_PURCHASE_INFO:
		"Er is een fout opgetreden tijdens het lezen van details van dit domein. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	DOMAIN_ERR_35_FAILED_PARSING_ADDRESS_FROM_HOSTFACT:
		"Het adres vanuit Hostfact kan niet worden gesplitst in de straatnaam, huisnummer en huisnummertoevoeging. Neem contact op met de developers",

	DOMAIN_ERR_37_TRANSFER_NOT_AVAILABLE_AT_THE_MOMENT:
		"Het verhuizen van één van deze domeinnamen is op dit moment niet mogelijk. Neem contact op met onze klantenservice als dit probleem aanhoudt.",
	/* ---------------------------------- BASE ---------------------------------- */
	error_code: "Foutcode",
	error_msg: "Foutmelding",

	/* ------------------------------ ORDER RELATED ----------------------------- */
	ORDER_ERR_1_ORDER_NOT_FOUND: "",

	ORDER_ERR_2_ERROR_DURING_PRICE_CALCULATION:
		"Er is een fout opgetreden tijdens het berekenen van de prijs van een product op de order. Neem contact op met onze klantenservice.",

	/* ------------------------------- PBS RELATED ------------------------------ */
	PBS_ERR_1_NOT_A_RESELLER:
		"Uw account heeft geen reseller-status, hierdoor kunt u de PBS niet in reseller-modus aanvragen.",
	PBS_ERR_2_DATASTORE_NAME_NOT_UNIQUE:
		"U beschikt al over een datastore met dezelfde naam. Uw datastore naam dient uniek te zijn.",
	PBS_ERR_3_FREE_ALREADY_ENABLED:
		"Het is niet mogelijk om als debiteur meer dan 1 gratis variant van PBS te bestellen.",
	PBS_ERR_4_DEBTOR_NOT_ALLOWED_ON_LOCATION:
		"Het is niet mogelijk om een PBS aan te vragen op de geselecteerde locatie. Selecteer een andere locatie of neem contact op met onze klantenservice.",
	PBS_ERR_5_ERROR_EMAIL_ADDRESS_REQUIRED:
		"Voor het ontvangen van foutmeldingen is een e-mailadres verplicht. Deze kan ingesteld worden op de vorige pagina.",
	PBS_ERR_6_LOCATION_HAS_NO_DEFAULT_NODE:
		"Momenteel kunnen we geen geschikte server vinden op de geselecteerde locatie om een nieuwe PBS op uit te rollen. Neem contact op met onze klantenservice als dit probleem aanhoudt.",
	PBS_ERR_7_USER_REGISTRATION_FAILED:
		"Er is een fout opgetreden bij het registreren van een nieuwe gebruiker op de PBS-locatie. Als dit probleem aanhoudt, neem dan contact op met onze klantenservice.",
	PBS_ERR_8_FAILED_TO_CREATE_ZFS_DATASTORE:
		"Er is een fout opgetreden tijdens het aanmaken van een nieuwe ZFS-datastore. Als dit probleem aanhoudt, neem dan contact op met onze klantenservice.",
	PBS_ERR_9_FAILED_TO_CREATE_PBS_DATASTORE:
		"Er is een fout opgetreden tijdens het aanmaken van een nieuwe PBS-datastore. Als dit probleem aanhoudt, neem dan contact op met onze klantenservice.",
	PBS_ERR_10_FAILED_TO_CREATE_PBS_USER_PERMISSIONS:
		"Er is een fout opgetreden bij het toewijzen van rechten aan de gebruiker voor toegang tot de datastore. Als dit probleem aanhoudt, neem dan contact op met onze klantenservice.",
	PBS_ERR_11_NOT_FOUND: "De geselecteerde PBS is niet gevonden.",
	PBS_ERR_12_LIMIT_LOWER_THEN_CURRENT_USAGE:
		"Het nieuwe limiet voor de datastore is lager dan het huidige verbruik. Verhoog het limiet om door te kunnen gaan.",
	PBS_ERR_13_RESELLER_RELATION_NOT_UPDATABLE:
		"U kunt de relatie niet wijzigen van een PBS als deze voor een klant is uitgerold (reseller modus). ",
	PBS_ERR_14_CANCELLATION_ALREADY_PENDING: "Deze dienst (PBS) is al opgezegd.",
	PBS_ERR_15_CANCELLATION_NOT_PENDING:
		"De dienst is niet beëindigd, daarom is het niet mogelijk de opzegging te annuleren.",
	PBS_ERR_16_LOCATION_NOT_FOUND: "De opgegeven PBS locatie kon niet gevonden worden.",
	PBS_ERR_17_NODE_NOT_FOUND:
		"Momenteel kunnen we geen server vinden op de geselecteerde locatie. Neem contact op met onze klantenservice als dit probleem aanhoudt.",
	PBS_ERR_18_FAILED_TO_CREATE_PBS_API_TOKEN:
		"Momenteel kan er geen nieuwe API-token aangemaakt worden op de PBS-node. Neem contact op met onze klantenservice als dit probleem aanhoudt.",
	PBS_ERR_19_FAILED_TO_CREATE_PBS_API_TOKEN_PERMISSIONS:
		"Momenteel kunnen er geen PBS-permissies toegevoegd worden aan de API-token op de PBS-node. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	/* -------------------------------- PBS SYNC -------------------------------- */
	PBS_SYNC_ERR_1_SYNC_FAILED_CREATE_REMOTE:
		"De remote host kon niet aangemaakt worden op de destination PBS node. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_2_SYNC_FAILED_CREATE_SYNC_JOB:
		"Er kon geen sync-job aangemaakt worden op de destination PBS node. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_3_SYNC_FAILED_CREATE_SYNC_IN_DATABASE:
		"De remote host kon niet aangemaakt worden in onze database. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_4_SYNC_FAILED_CREATE_FATAL_ERROR:
		"Momenteel kan er geen PBS sync aangemaakt worden. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_5_COULD_NOT_READ_REMOTE:
		"Momenteel kan de remote PBS niet gelezen worden vanuit Proxmox.",

	PBS_SYNC_ERR_6_COULD_NOT_READ_SYNC_JOB:
		"Momenteel kan de sync-job niet gelezen worden vanuit Proxmox.",

	PBS_SYNC_ERR_7_COULD_NOT_READ_SYNC_RECORD_FROM_DATABASE:
		"Momenteel kan de sync-job niet gelezen worden uit de database.",

	PBS_SYNC_ERR_8_SYNC_READ_SYNC_FATAL_ERROR:
		"Er trad een fout op bij het ophalen van de sync-informatie. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_9_SYNC_FAILED_UPDATE_REMOTE:
		"De remote host kon momenteel niet geüpdatet worden binnen Proxmox.",

	PBS_SYNC_ERR_10_SYNC_FAILED_UPDATE_SYNC_JOB:
		"De sync-job kon momenteel niet geüpdatet worden binnen Proxmox.",

	PBS_SYNC_ERR_11_SYNC_UPDATE_SYNC_IN_DATABASE:
		"De sync-job kon momenteel niet geüpdatet worden in de database.",

	PBS_SYNC_ERR_12_SYNC_UPDATE_FATAL_ERROR:
		"De PBS-sync kon momenteel niet geüpdatet worden. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_13_DELETE_REMOTE_ERROR: "De remote host kon niet verwijderd worden uit Proxmox.",

	PBS_SYNC_ERR_14_DELETE_SYNC_JOB_ERROR: "De sync-job kon niet verwijderd worden uit Proxmox.",

	PBS_SYNC_ERR_15_DELETE_SYNC_FROM_DATABASE_ERROR:
		"De sync-job kon niet verwijderd worden uit de database.",

	PBS_SYNC_ERR_16_DELETE_SYNC_FATAL_ERROR:
		"De sync-informatie kon niet verwijderd worden. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_17_REMOTE_HOST_NAME_NOT_PROVIDED_OR_INVALID:
		"De naam van de remote host is niet opgegeven of ongeldig.",

	PBS_SYNC_ERR_18_REMOTE_HOST_PORT_NOT_PROVIDED_OR_INVALID:
		"De poort van de remote host is niet opgegeven of ongeldig.",

	PBS_SYNC_ERR_19_NO_SOURCE_PROVIDED_OR_INVALID:
		"Geen bron opgegeven. Een sync-job kan niet aangemaakt worden zonder bron.",

	PBS_SYNC_ERR_20_REMOTE_API_USER_OR_TOKEN_MISSING_OR_INVALID:
		"De API-gebruiker of token ontbreekt of is ongeldig.",

	PBS_SYNC_ERR_21_REMOTE_FINGERPRINT_REQUIRED_OR_INVALID:
		"De fingerprint is vereist wanneer de host een self-signed certificaat gebruikt.",

	PBS_SYNC_ERR_22_SYNC_PBS_ID_NOT_PROVIDED:
		"Het PBS-ID is niet opgegeven. Dit is vereist wanneer de bron-PBS vanuit Tuxis komt.",

	PBS_SYNC_ERR_23_NO_SCHEDULE_PROVIDED_OR_INVALID:
		"Er is geen synchronisatie-interval opgegeven of het interval is ongeldig.",

	PBS_SYNC_ERR_24_COULD_NOT_ESTABLISH_PAYLOAD:
		"De payload kon niet worden opgebouwd. Neem contact op met onze klantenservice als dit probleem aanhoudt.",

	PBS_SYNC_ERR_25_INVALID_FINGERPRINT:
		"De opgegeven fingerprint is ongeldig. Controleer je invoer.",

	PBS_SYNC_ERR_26_PUSH_METHOD_NOT_SUPPORTED_IN_THIS_PORTAL_VERSION:
		"De push-methode wordt niet ondersteund in deze versie van het portaal.",

	PBS_SYNC_ERR_27_REMOTE_TEST_FAILED:
		"De verbindingstest met de remote host is mislukt. Controleer of de invoer correct is.",

	PBS_SYNC_ERR_28_REMOTE_FETCH_DATASTORE_FAILED:
		"De datastore kon niet gelezen worden vanaf de remote host. Controleer of de naam correct is en of deze bestaat op de opgegeven remote.",

	/* -------------------------- PRODUCT GROUP RELATED ------------------------- */
	PRODUCT_GROUP_ERR_1_PRODUCT_GROUP_NOT_FOUND: "Productgroep niet gevonden.",

	/* ---------------------------- RELATION RELATED ---------------------------- */
	RELATION_ERR_1_RELATION_NOT_FOUND: "De relatie is niet gevonden.",

	RELATION_ERR_2_RELATION_DETAILS_NOT_FOUND:
		"De relatie details zijn niet gevonden bij deze relatie.",

	RELATION_ERR_3_RELATION_CANT_BE_DELETED_HAS_DOMAINS_LINKED:
		"De relatie kan niet worden verwijderd, er zijn domeinen aan verbonden.",

	RELATION_ERR_4_RELATION_CANT_BE_DELETED_HAS_ITEMS_LINKED:
		"De relatie kan niet worden verwijderd, er zijn items aan verbonden.",

	RELATION_ERR_5_CANNOT_UPDATE_RELATION:
		"Kan relatie niet updaten, valideer je input of neem contact op met een van onze supportmedewerkers.",

	RELATION_ERR_6_CANNOT_CREATE_RELATION:
		"Kan relatie niet aanmaken, valideer je input of neem contact op met een van onze supportmedewerkers.",

	RELATION_ERR_7_RELATION_DOMAIN_DETAILS_ALREADY_EXIST:
		"Er is geprobeerd nieuwe domeinrelatiegegevens voor deze relatie aan te maken, maar deze gegevens bestaan al. Neem contact op met onze klantenservice als het probleem aanhoudt.",

	RELATION_ERR_8_COMPANY_COC_NUMBER_REQUIRED:
		'Het "KVK nummer" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_9_COMPANY_VAT_NUMBER_REQUIRED:
		'Het "BTW nummer" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_10_COMPANY_TRADEMARK_COUNTRY_REQUIRED:
		'Het "Trademark land" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_11_COMPANY_TRADEMARK_NAME_REQUIRED:
		'De "Trademark naam" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_12_COMPANY_TRADEMARK_NUMBER_REQUIRED:
		'Het "Trademark nummer" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_13_PERSON_ID_NUMBER_REQUIRED:
		'Het "Nummer identiteitskaart" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_14_PERSON_ID_ISSUE_DATE_REQUIRED:
		'De "Uitgiftedatum identiteitsbewijs" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_15_PERSON_ID_ISSUER_REQUIRED:
		'De "Uitgevende instantie identiteitsbewijs" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_16_PERSON_BIRTH_DATE_REQUIRED:
		'De "Geboortedatum" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_17_COUNTRY_OF_BIRTH_REQUIRED:
		'Het "Geboorteland" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_18_CITY_OF_BIRTH_REQUIRED:
		'De "Geboorteplaats" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_19_GIVEN_NAME_REQUIRED:
		'De "Voornaam" en "Achternaam" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_20_ZIP_CODE_REQUIRED:
		'De "Postcode" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	RELATION_ERR_21_COMPANY_NAME_REQUIRED:
		'De "Bedrijfsnaam" is vereist voor één van de gekoppelde domeinen. Vul dit veld in en sla opnieuw de domeingegevens van deze relatie op.',

	/* ------------------------------ USER RELATED ------------------------------ */
	USER_ERR_1_NOT_ALLOWED_AS_NON_SUPERUSER: "U bent niet gemachtigd om deze actie uit te voeren.",

	USER_ERR_2_USER_NOT_FOUND:
		"De gebruiker is niet gevonden. Als dit niet correct is, neem dan contact op met onze klantenservice.",

	USER_ERR_3_UPDATE_SEEN_HOMEPAGE_TUTORIAL_FAILED:
		"Er is een fout opgetreden bij het bijwerken dat u de homepagina tutorial heeft gezien.",

	USER_ERR_7_DUPLICATE_SSH_KEY: "De ingevoerde public SSH-key bestaat al in uw account.",

	/* ------------------------------- VPS RELATED ------------------------------ */
	VPS_ERR_1_UNKNOWN_DATACENTER:
		"Het door u gekozen datacenter kan helaas niet geselecteerd worden voor het uitrollen van nieuwe VPS'en.",
	VPS_ERR_2_TEMPLATE_NOT_FOUND:
		"Het door u geselecteerde besturingssysteem of template kon niet worden gevonden op onze server.",
	VPS_ERR_3_TEMPLATE_BACKUP_NOT_FOUND:
		"Het door u geselecteerde besturingssysteem of template heeft geen back-up op onze server. Hierdoor is het op dit moment niet mogelijk om de VPS uit te rollen.",
	VPS_ERR_4_TEMPLATE_CONFIG_NOT_FOUND:
		"Op dit moment kunnen we de config van het door u geselecteerde besturingssysteem of template niet ophalen.",
	VPS_ERR_5_INSUFFICIENT_CORES:
		"De door u gekozen configuratie heeft minder CPU-cores dan vereist door het door u geselecteerde besturingssysteem of template.",
	VPS_ERR_6_TOO_MANY_CORES:
		"De door u gekozen configuratie heeft meer CPU-cores dan is toegestaan volgens de toegestane limiet.",
	VPS_ERR_7_INSUFFICIENT_MEMORY:
		"De door u gekozen configuratie heeft minder geheugen dan vereist door het door u geselecteerde besturingssysteem of template.",
	VPS_ERR_8_TOO_MUCH_MEMORY:
		"De door u gekozen configuratie heeft meer geheugen dan is toegestaan volgens de toegestane limiet.",
	VPS_ERR_9_INSUFFICIENT_STORAGE:
		"De door u gekozen configuratie heeft minder opslagruimte dan vereist door het door u geselecteerde besturingssysteem of template.",
	VPS_ERR_10_TOO_MUCH_STORAGE:
		"De door u gekozen configuratie heeft meer opslagruimte dan is toegestaan volgens de toegestane limiet.",
	VPS_ERR_11_PUBLIC_NETWORK_REQUIRED:
		"Een internetverbinding is vereist wanneer er geen private network beschikbaar is.",
	VPS_ERR_12_PRIVATE_NETWORK_EXISTS:
		"Er bestaat al een private network met de door u opgegeven naam.",
	VPS_ERR_13_DATACENTER_NODES_UNAVAILABLE:
		"Het is momenteel niet mogelijk om uw VPS in ons datacenter uit te rollen. Als dit probleem aanhoudt, neem dan contact op met onze supportafdeling.",
	VPS_ERR_14_CANNOT_SHRINK_STORAGE:
		"Uw VPS kan niet worden bijgewerkt omdat de huidige schijfgrootte kleiner is dan de vereiste grootte. Het is niet mogelijk om de schijf te verkleinen.",
	VPS_ERR_15_CANNOT_DOWNGRADE_SNAPSHOTS:
		"Uw VPS kan niet worden bijgewerkt omdat u probeert het aantal snapshots te verlagen terwijl er nog actieve snapshots zijn. Verwijder eerst deze snapshots voordat u verdergaat met de afschaling.",
	VPS_ERR_16_QEMU_ALREADY_RUNNING:
		"De VPS is momenteel al actief. Het kan enkele seconden duren voordat dit zichtbaar is.",
	VPS_ERR_17_QEMU_NOT_RUNNING:
		"De VPS is momenteel al uitgeschakeld. Het kan enkele seconden duren voordat dit zichtbaar is.",
	VPS_ERR_18_QEMU_NOT_FOUND: "De VPS is niet gevonden.",
	VPS_ERR_19_INVALID_SNAPSHOT_NAME:
		"Ongeldige snapshot naam: Er bestaat al een snapshot met dezelfde naam.",
	VPS_ERR_20_INSUFFICIENT_SNAPSHOTS:
		"Er zijn onvoldoende snapshots beschikbaar om een nieuwe uit te rollen. Verhoog het aantal beschikbare snapshots voor de VPS en probeer het opnieuw.",
	VPS_ERR_21_SNAPSHOT_NOT_FOUND:
		"Uw snapshot kan niet worden gewijzigd of verwijderd omdat deze niet gevonden kon worden.",
	VPS_ERR_22_PRIVATE_NETWORK_NOT_FOUND: "Het door u aangevraagde private network is niet gevonden.",
	VPS_ERR_23_SNAPSHOT_EXPIRATION_DATE_INVALID:
		"Er is een fout opgetreden tijdens het lezen van de snapshots. Neem contact op met onze klantenservice als dit probleem aanhoudt.",
};

export default error_codes;
